/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, {useEffect, useState} from "react";
import {
    Box,
    Button, Form, FormField, Layer,
    Page,
    PageContent,
    TextArea, TextInput, Text,
    FileInput,
    Heading,
    Select
} from 'grommet'

type Props = {
    buttonText: string
}

const SendMessage: React.FC<Props> = (props) => {
    const [showModal, setShowModal] = useState<boolean>(false)


    return (
        <>
            <Button primary label={props.buttonText} onClick={() => setShowModal(true)} />
            {showModal && (
                <Layer
                    onEsc={() => setShowModal(false)}
                    onClickOutside={() => setShowModal(false)}
                    modal={true}
                    animate={true}

                >
                    <Box
                        width={"large"}
                        pad={"medium"}
                    >

                    </Box>
                </Layer>
            )}
        </>
    )
}


export default SendMessage;
